// assets/reorder.js

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.reorder-button').forEach(btn => {
    btn.addEventListener('click', async () => {
      const orderId = btn.dataset.orderId;
      try {
        // 1) Bestellung abrufen
        const res = await fetch(`/account/orders/${orderId}.json`);
        if (!res.ok) throw new Error(`Fetch order failed (Status ${res.status})`);
        const data = await res.json();
        const order = data.order;
        console.log('🛒 [Reorder] Order payload:', order);

        // 2) Jedes Line Item verarbeiten
        for (const item of order.line_items) {
          // Basis‑Properties
          const props = { ...(item.properties || {}) };

          // Additional‑Fields mergen, falls vorhanden
          if (item.additional_fields && typeof item.additional_fields === 'object') {
            Object.entries(item.additional_fields).forEach(([key, value]) => {
              props[key] = value;
            });
          } else {
            console.warn('⚠️ [Reorder] No additional_fields on item', item);
          }

          // Artikel in den Warenkorb
          const addRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id:        item.variant_id,
              quantity:  item.quantity,
              properties:props
            })
          });
          if (!addRes.ok) {
            const errText = await addRes.text();
            throw new Error(`Add to cart failed (Status ${addRes.status}): ${errText}`);
          }
          console.log(`✅ [Reorder] Added variant ${item.variant_id} ×${item.quantity}`);
        }

        // 3) Zur Kasse leiten
        window.location.href = '/checkout';
      } catch (err) {
        console.error('🚨 [Reorder] Error:', err);
        alert(`Fehler beim Wiederbestellen:\n${err.message}`);
      }
    });
  });
});
